module.exports = __webpack_public_path__ + "img/arrow-left-right.00d7f11d.svg";